import { render, staticRenderFns } from "./CarNewRelease.vue?vue&type=template&id=c127ca02"
import script from "./CarNewRelease.vue?vue&type=script&lang=js"
export * from "./CarNewRelease.vue?vue&type=script&lang=js"
import style0 from "./CarNewRelease.vue?vue&type=style&index=0&id=c127ca02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports